import { MeetOpsQueryResult } from "@app/analytics/hooks/metrics/useMetricsQuery";
import { getMetricMetaById } from "@app/analytics/meetops/metrics";

import { QueryDimension, QueryMetric } from "../meetops/types";

export const meetingSize = {
  small: {
    meetingScore: 77,
    engagement: 82,
    sentiment: 77,
    onTimeRate: 0.83,
    meetingCount: 0,
  },
  medium: {
    meetingScore: 75,
    engagement: 74,
    sentiment: 76,
    onTimeRate: 0.69,
    meetingCount: 0,
  },
  large: {
    meetingScore: 77,
    engagement: 72,
    sentiment: 79,
    onTimeRate: 0.58,
    meetingCount: 0,
  },
};

export const observedDuration = {
  "0": {
    meetingScore: 78,
    engagement: 79,
    sentiment: 78,
    onTimeRate: 0.79,
    meetingCount: 0,
  },
  "1": {
    meetingScore: 76,
    engagement: 77,
    sentiment: 76,
    onTimeRate: 0.73,
    meetingCount: 0,
  },
  "2": {
    meetingScore: 75,
    engagement: 76,
    sentiment: 76,
    onTimeRate: 0.7,
    meetingCount: 0,
  },
};

export const dayOfWeek = {
  mon: {
    meetingScore: 76,
    engagement: 77,
    sentiment: 77,
    onTimeRate: 0.75,
    meetingCount: 0,
  },
  tue: {
    meetingScore: 76,
    engagement: 78,
    sentiment: 77,
    onTimeRate: 0.73,
    meetingCount: 0,
  },
  wed: {
    meetingScore: 77,
    engagement: 78,
    sentiment: 77,
    onTimeRate: 0.74,
    meetingCount: 0,
  },
  thu: {
    meetingScore: 76,
    engagement: 78,
    sentiment: 77,
    onTimeRate: 0.78,
    meetingCount: 0,
  },
  fri: {
    meetingScore: 76,
    engagement: 79,
    sentiment: 77,
    onTimeRate: 0.76,
    meetingCount: 0,
  },
};

export const hour = {
  hour_bin_08_09: {
    meetingScore: 77,
    engagement: 75,
    sentiment: 79,
    onTimeRate: 0.71,
    meetingCount: 0,
  },
  hour_bin_09_10: {
    meetingScore: 76,
    engagement: 78,
    sentiment: 76,
    onTimeRate: 0.78,
    meetingCount: 0,
  },
  hour_bin_10_11: {
    meetingScore: 76,
    engagement: 77,
    sentiment: 77,
    onTimeRate: 0.74,
    meetingCount: 0,
  },
  hour_bin_11_12: {
    meetingScore: 76,
    engagement: 77,
    sentiment: 77,
    onTimeRate: 0.73,
    meetingCount: 0,
  },
  hour_bin_12_13: {
    meetingScore: 78,
    engagement: 79,
    sentiment: 78,
    onTimeRate: 0.74,
    meetingCount: 0,
  },
  hour_bin_13_14: {
    meetingScore: 75,
    engagement: 78,
    sentiment: 76,
    onTimeRate: 0.76,
    meetingCount: 0,
  },
  hour_bin_14_15: {
    meetingScore: 75,
    engagement: 78,
    sentiment: 76,
    onTimeRate: 0.74,
    meetingCount: 0,
  },
  hour_bin_15_16: {
    meetingScore: 77,
    engagement: 79,
    sentiment: 78,
    onTimeRate: 0.78,
    meetingCount: 0,
  },
  hour_bin_16_17: {
    meetingScore: 78,
    engagement: 80,
    sentiment: 78,
    onTimeRate: 0.78,
    meetingCount: 0,
  },
  hour_bin_17_18: {
    meetingScore: 78,
    engagement: 77,
    sentiment: 78,
    onTimeRate: 0.76,
    meetingCount: 0,
  },
  hour_bin_18_19: {
    meetingScore: 77,
    engagement: 78,
    sentiment: 78,
    onTimeRate: 0.78,
    meetingCount: 0,
  },
};

const READ_AVERAGES = { meetingSize, observedDuration, hour, dayOfWeek };

// formats read average data as a MeetingOpsQueryResult
export const getReadAvgData = (
  dimension: QueryDimension
): MeetOpsQueryResult => {
  const averageData = READ_AVERAGES[dimension as keyof typeof READ_AVERAGES];
  if (!averageData) {
    return { results: [] };
  }

  const data = Object.keys(averageData).map((key) => {
    const metricData = averageData[key as keyof typeof averageData];
    return Object.keys(metricData).reduce(
      (obj: any, metric: string) => {
        const metricMeta = getMetricMetaById(metric as QueryMetric);

        obj[metric as QueryMetric] = {
          value: metricMeta.toValue(metricData[metric as QueryMetric]),
          formattedValue: metricMeta.toFormat(
            metricMeta.toValue(metricData[metric as QueryMetric])
          ),
        };
        return obj;
      },
      { [dimension]: key } as any
    );
  });

  return { results: [{ data }] };
};
